import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { flushSync } from "react-dom";
import { useUsersManagementContext } from "./users-management-context";
const SearchContext = React.createContext(undefined);
SearchContext.displayName = "SearchContext";
export const SearchProvider = ({ children, }) => {
    const inputRef = React.useRef(null);
    const { state: { searchQuery }, dispatch, } = useUsersManagementContext();
    const [searchValue, setSearchValue] = React.useState(searchQuery || "");
    const clearSearch = React.useCallback(() => {
        flushSync(() => {
            setSearchValue("");
            dispatch({ type: "FILTER_BY_SEARCH", searchQuery: "" });
        });
        inputRef.current?.focus();
    }, [dispatch]);
    return (_jsx(SearchContext.Provider, { value: { inputRef, clearSearch, searchValue, setSearchValue }, children: children }));
};
export const useSearchContext = () => {
    const context = React.useContext(SearchContext);
    if (!context) {
        throw new Error("useSearchContext must be used within a SearchProvider");
    }
    return context;
};
//# sourceMappingURL=search-provider.js.map